import { useEffect } from "react";

/**
 * useTabLeaveHook:
 * 1. Prevents accidental tab close via `beforeunload`
 *    (Browsers show their own native warning; we can only trigger it – text is ignored.)
 * 2. Swaps document.title when the tab loses focus ("👋 Komm zurück! – FREEAYTO")
 *    and restores the original title on refocus.
 */
const useTabLeaveHook = ({
  awayTitle = "👋 Komm zurück! · FREEAYTO",
  enableUnloadPrompt = true,
} = {}) => {
  useEffect(() => {
    let originalTitle = document.title;

    const onVisibility = () => {
      if (document.hidden) {
        originalTitle = document.title;
        document.title = awayTitle;
      } else {
        document.title = originalTitle;
      }
    };

    const onBeforeUnload = (e) => {
      if (!enableUnloadPrompt) return;
      // Modern browsers ignore the message but require these settings to prompt
      e.preventDefault();
      e.returnValue = "Bist du sicher, dass du gehen willst? Wir sichern gerade unseren Content für dich…";
      return e.returnValue;
    };

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("beforeunload", onBeforeUnload);

    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("beforeunload", onBeforeUnload);
      // restore title in case component unmounts while hidden
      if (document.title !== originalTitle) document.title = originalTitle;
    };
  }, [awayTitle, enableUnloadPrompt]);
};

export default useTabLeaveHook;
